import { orchestrator } from 'satcheljs';
import { updateCalendarEvents } from 'owa-calendar-compose-form-actions';
import { getOpenedForm, setEvent, setOriginalEvent } from 'owa-calendar-compose-store-manager';
import cloneEvent from 'owa-calendar-forms-common/lib/utils/cloneEvent';
import { updateStartEndWithTimeZone } from 'owa-calendar-types';

orchestrator(updateCalendarEvents, ({ event, formId }) => {
    if (getOpenedForm(formId)) {
        let updatedEvent = cloneEvent(event);
        let updatedOriginalEvent = cloneEvent(event);
        updateStartEndWithTimeZone(updatedEvent);
        updateStartEndWithTimeZone(updatedOriginalEvent);

        setEvent(formId, updatedEvent);
        setOriginalEvent(formId, updatedOriginalEvent);
    }
});
